<template>
  <div class="card card-article has-background-table-second-color mgb-10px">
    <div class="columns is-marginless is-paddingless">
      <div class="column is-4">
        <b-autocomplete v-model="nomBailleur"
                        :open-on-focus="false"
                        :data="bailleurs"
                        field="nomCommercial"
                        :placeholder="$t('catalogue.produitConcessionnaire.actions.searchBailleur')"
                        @input="getBailleur"
                        :loading="isFetching"
                        @select="selectBailleur">
          <template slot-scope="props">
            {{ props.option.nomWithAdresseAndCompteComptable }}
          </template>
          <template slot="empty">
            <div v-if="!isFetching">
              {{$t('general.autocomplete.noRslt')}}
            </div>
            <div v-else>
              {{$t('general.autocomplete.search')}}
            </div>
          </template>
        </b-autocomplete>
      </div>
      <div class="column is-4">
        <input-currency v-model="ligne.pourcentage">
        </input-currency>
      </div>
      <div class="column is-4">
        <a class="is-pulled-right"
           @click="$emit('deleteLigne')">
          <b-icon
            icon="delete-forever"
            type="is-danger">
          </b-icon>
        </a>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import { getAll } from '@/api/tiers';
import {
  TIERS_SOUS_TYPE_BAILLEUR_ADMINISTRATION_ET_ASSIMILEE,
  TIERS_SOUS_TYPE_BAILLEUR_CONCESSION, TIERS_SOUS_TYPE_BAILLEUR_PRIVE,
  TIERS_SOUS_TYPE_BAILLEUR_PRO,
  TIERS_TYPE_FOURNISSEUR,
} from '@/configuration/tiers/tiersConf';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import messageErreur from '@/services/general/messageErreur';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import inputCurrency from '@/components/general/inputCurrency';

const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    ligne: {
      type: Object,
      required: true,
    },
    produitsConcessionnaire: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      bailleurs: [],
      isFetching: false,
      nomBailleur: null,
    };
  },
  components: {
    inputCurrency,
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  methods: {
    getBailleur: debounce(async function bailleurData(nomBailleur) {
      try {
        this.isFetching = true;
        const bailleursList = (await getAll({
          query: {
            type: TIERS_TYPE_FOURNISSEUR,
            archive: false,
            auto: nomBailleur,
            sousType: [
              TIERS_SOUS_TYPE_BAILLEUR_PRO,
              TIERS_SOUS_TYPE_BAILLEUR_CONCESSION,
              TIERS_SOUS_TYPE_BAILLEUR_ADMINISTRATION_ET_ASSIMILEE,
              TIERS_SOUS_TYPE_BAILLEUR_PRIVE,
            ],
            societeId: this.societeActiveId,
            limit: NO_PAGINATION,
          },
        })).data.result.items;
        bailleursList.map((bailleur) => {
          bailleur.nomWithAdresseAndCompteComptable = bailleur.code + ' - ' + bailleur.nomCommercial + ' - '
            + adressFullStringGetter(bailleur.adressePostale, false);
          if (bailleur.compteComptable) {
            bailleur.nomWithAdresseAndCompteComptable += ' - ' + bailleur.compteComptable;
          }
          return bailleur;
        });
        this.bailleurs = bailleursList.filter((bailleur) => {
          return !this.produitsConcessionnaire.find((produit) => {
            return produit.tiersId === bailleur.id;
          });
        });
        this.isFetching = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetching = false;
        throw e;
      }
    }, 500),
    selectBailleur(bailleur) {
      if (!bailleur) return;
      this.ligne.tiersId = bailleur.id;
      this.ligne.tiers = bailleur;
      this.nomBailleur = '';
    },
  },
  mounted() {
    if (this.ligne.tiers) this.nomBailleur = this.ligne.tiers.nomCommercial;
  },
};
</script>
